import { get } from './http'

export const getCategoryListApi = data => get('product/cate_list',data); //登录
export const getNewsInfoApi = data => get('about/news_info',data); //获取新闻详情
export const getProductListApi = data => get('product/list',data); //产品列表
export const getProductContentApi = data => get('product/info',data); //产品列表
export const getHomeApi = data => get('home',data); //首页产品列表
export const getNewsListApi = data => get('about/news_list',data); //新闻列表
export const getBannerListApi = data => get('banner/list',data); //banner列表

// 解决方案列表
export const getSolutionCategoryListApi = data => get('solution/cate_list',data); //登录
export const getSolutionListApi = data => get('solution/list',data); //产品列表
export const getSolutionContentApi = data => get('solution/info',data); //产品列表

// 招聘
export const getHireListApi = data => get('about/hire_list',data); //产品列表
export const getAboutUsApi = data => get('about/cate_list',data); //产品列表
